import produce from 'immer';
import {
  EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL,
  BROWSER_ADD_ASSET_WITH_CAMPAIGN,
  EMAIL_BROWSER,
  EMAIL_BROWSER_EMAILS_IN_CAMPAIGN,
  EMAIL_BROWSER_CURATION_UNDO,
  BROWSER_CREATED_ASSET_DRAFT,
  BROWSER_CREATE_ASSET,
  BROWSER_CREATE_ASSET_DRAFT,
  BROWSER_EDITIONS_OF_CAMPAIGN,
  BROWSER_REMOVE_ASSET_DRAFT,
  EMAIL_BROWSER_ADD_EMAIL,
} from '../../constants/actionTypes';
import { IArticlesAction, IBrowserAssets, IEmailBrowserEmail } from '../Content/interfaces';
import { getQueryAssetId } from './utils';
import { CAMPAIGN_DELETE, DEFAULT_CAMPAIGN_IMAGE, EDITION_NAME_CHANGE } from '../../constants/types';
import { DEFAULT_IMAGE_PLACEHOLDER } from 'constants/index';
/*
 * state for AssetBrowser list
 */
const emailBrowserInitialState = {
  emails: {
    loading: false,
    page: 0,
    data: Array<IEmailBrowserEmail>(),
    totalCount: 0,
  },
  emailsInCampaign: {
    data: Array<IEmailBrowserEmail>(),
    page: 0,
    loading: false,
    totalCount: 0,
  },
  newEmailCreated: false,
  addNewEmail: {
    loading: false,
    success: false,
    fail: false,
  },
  emailAlreadyExists: false,
  addEmail: {
    loading: false,
    success: false,
    fail: false,
  },
  searchLoading: false,
  searchFail: false,
  newAsset: Array<any>(),
  editionsInAsset: Array<any>(),
  totalEmailsCount: 0,
  showRedColor: false,
};

export const emailBrowserReducer = produce((draft = emailBrowserInitialState, action: IArticlesAction) => {
  const { type } = action;
  switch (type) {
    //*  LISTING FOR ALL Emails IN EMAIL BUILDER
    case EMAIL_BROWSER.LOAD:
      draft.emails.loading = true;
      return draft;

    case EMAIL_BROWSER.LOAD_SUCCESS:
      draft.emails.loading = false;
      let emailIds = [...draft.emails.data].map((item) => item.emailId);
      // filtering the data so that current email don't repeat in the array
      const filtered = action.payload.emails.filter(({ emailId }: { emailId: number }) => !emailIds.includes(emailId));
      draft.emails.data = [...draft.emails.data, ...filtered];
      draft.emails.page = draft.emails.page + 1;
      draft.emails.totalCount = action.payload.totalCount;
      return draft;

    case EMAIL_BROWSER.LOAD_FAIL:
      draft.emails.loading = false;
      return draft;

    case EMAIL_BROWSER.ADD_EMAIL_DATA:
      let emailData: Array<IEmailBrowserEmail> = [...draft.emails.data];
      emailData.push(action.payload);
      return {
        ...draft,
        emails: {
          ...draft.emails,
          data: emailData,
        },
      };

    case EMAIL_BROWSER.RESET:
      draft.emails.loading = false;
      draft.emails.page = 0;
      draft.emails.data = [];
      draft.emails.totalCount = 0;
      return draft;

    //* Remove email from emailBrowser
    case EMAIL_BROWSER.REMOVE_EMAIL:
      draft.emails.data = draft.emails?.data.filter((item: any) => item.emailId !== action.payload?.emailId);
      draft.emailsInCampaign.data = draft.emailsInCampaign?.data.filter(
        (item: any) => item.emailId !== action.payload?.emailId,
      );
      return draft;

    //* Rename email
    case EMAIL_BROWSER.SET_EMAIL_NAME:
      const emailIndexToBeUpdated = draft.emails?.data.findIndex(
        (email: any) => action.payload.emailId === email.emailId,
      );
      const emailInCampaignsIndexToBeUpdated = draft.emailsInCampaign?.data.findIndex(
        (email: any) => action.payload.emailId === email.emailId,
      );
      if (emailIndexToBeUpdated !== -1) {
        draft.emails.data[emailIndexToBeUpdated].name = action.payload.emailName;
      }
      if (emailInCampaignsIndexToBeUpdated >= 0)
        draft.emailsInCampaign.data[emailInCampaignsIndexToBeUpdated].name = action.payload.emailName;
      return draft;

    //*  LISTING FOR THE ASSETS FOR A SPECIFIC CAMPAIGN. IN SMART SOURCED CONTENT
    case EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD:
      draft.emailsInCampaign.loading = true;
      draft.emails.loading = true;
      return draft;

    case EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD_SUCCESS:
      draft.emails.loading = false;
      draft.emailsInCampaign.loading = false;
      draft.emailsInCampaign.data = [...draft.emailsInCampaign.data, ...action.payload.emails];
      draft.emailsInCampaign.page = draft.emailsInCampaign.page + 1;
      draft.emailsInCampaign.totalCount = action.payload.totalCount;
      return draft;

    case EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD_FAIL:
      draft.emailsInCampaign.loading = false;
      draft.emailsInCampaign.data = [];
      return draft;

    case EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.RESET:
      draft.emailsInCampaign.loading = false;
      draft.emailsInCampaign.data = [];
      draft.emailsInCampaign.page = 0;
      draft.emails.loading = false;
      draft.emailsInCampaign.totalCount = 0;
      return draft;

    //* Add articles in emails
    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.SET_PREVIEW:
      const { img, emailId, articles, articles_count, last_update, images } = action.payload;
      const dummyPreviewImg = DEFAULT_IMAGE_PLACEHOLDER;

      draft.emails?.data?.map((item: any) => {
        if (item.emailId === emailId) {
          item.previewImage = img || dummyPreviewImg;
          item.recentlyAddedArticles = articles;
          item.articlesCount = articles_count;
          item.showUndo = true;
          item.lastUpdate = last_update;
          item.newlyCreated = false;
          item.recent = true;
          item.thumbnails = [...images, ...item.thumbnails];
        }
        return item;
      });
      draft.emailsInCampaign?.data?.map((elem: any) => {
        if (elem.emailId === emailId) {
          elem.previewImage = img || dummyPreviewImg;
          elem.recentlyAddedArticles = articles;
          elem.articlesCount = articles_count;
          elem.lastUpdate = last_update;
          elem.showUndo = true;
          elem.newlyCreated = false;
          elem.thumbnails = [...images, ...elem.thumbnails];
          elem.recent = true;
        }
        return elem;
      });
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET_RECENT:
      const email_ID = action.payload?.emailId;

      draft.emails?.data?.map((item: any) => {
        if (item.emailId === email_ID) {
          // item.newlyCreated = false;
          item.recent = false;
        }
        return item;
      });
      draft.emailsInCampaign?.data?.map((elem: any) => {
        if (elem.emailId === email_ID) {
          // elem.newlyCreated = false;
          elem.recent = false;
        }
        return elem;
      });
      return draft;

    //* for reseting the undo button
    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET_UNDO:
      // using snake case as it's not allowing define var emailId as it's already defined in previous block
      let email_id = action.payload.emailId;
      draft.emails?.data?.map((item: any) => {
        if (item.emailId === email_id) {
          item.recentlyAddedArticles = '';
          item.lastUpdate = '30 sec ago';
          item.showUndo = false;
          item.previewImage = '';
        }
        return item;
      });
      draft.emailsInCampaign?.data?.map((elem: any) => {
        if (elem.emailId === email_id) {
          elem.recentlyAddedArticles = '';
          elem.lastUpdate = '30 sec ago';
          elem.showUndo = false;
        }
        return elem;
      });
      return draft;

    //* Ipdate curation count
    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_BY_URL:
      let Email_Id = action.payload;
      draft.emails?.data.map((item: any) => {
        if (item.emailId === Email_Id) {
          item.articlesCount = item.articlesCount + 1;
        }
      });
      draft.emailsInCampaign?.data.map((item: any) => {
        if (item.emailId === Email_Id) {
          item.articlesCount = item.articlesCount + 1;
        }
      });
      return draft;

    //* Undo curation in email
    case EMAIL_BROWSER_CURATION_UNDO.SUCCESS:
      let email_Id = action.payload.emailId;
      let selectedArticles = action.payload.articles;
      let count = selectedArticles?.split(',').length;
      draft.emails?.data.map((item: any) => {
        if (item.emailId === email_Id) {
          item.recentlyAddedArticles = '';
          item.articlesCount = item.articlesCount - count;
          item.showUndo = false;
          item.undone = true;
          item.previewImage = '';
          switch (item?.articlesCount) {
            case 0:
              item.thumbnails = [];
              break;
            case 1:
              item.thumbnails = [item?.thumbnails[0]];
              break;
            case 2:
              item.thumbnails = [item?.thumbnails[0], item?.thumbnails[1]];
              break;

            default:
              break;
          }

          // if (item.articlesCount === 2) {
          //   item.thumbnail = [item.thumbnail[0], item.thumbnail[1]];
          // } else if (item.articlesCount === 1) {
          //   item.thumbnail = [item.thumbnail[0]];
          // } else {
          //   item.thumbnail = [];
          // }
        }
        return item;
      });
      draft.emailsInCampaign?.data?.map((elem: any) => {
        if (elem.emailId === email_Id) {
          elem.recentlyAddedArticles = '';
          elem.showUndo = false;
          elem.undone = true;
          elem.articlesCount = elem.articlesCount - count;
          elem.previewImage = '';
        }
        return elem;
      });
      return draft;

    case EMAIL_BROWSER_CURATION_UNDO.RESET:
      let tbr_emaiL_id = action?.payload?.emailId;
      // let tbr_count = selectedArticles.split(",").length;
      draft.emails?.data.map((item: any) => {
        if (item.emailId === tbr_emaiL_id) {
          item.recentlyAddedArticles = '';
          // item.articlesCount = item.articlesCount - tbr_count;
          item.undone = false;
        }
        return item;
      });
      draft.emailsInCampaign?.data?.map((item: any) => {
        if (item.emailId === tbr_emaiL_id) {
          item.recentlyAddedArticles = '';
          // item.articlesCount = item.articlesCount - tbr_count;
          item.undone = false;
        }
        return item;
      });
      return draft;

    //* Add new Email in Email Builder
    case EMAIL_BROWSER_ADD_EMAIL.ADD:
      draft.addNewEmail.loading = true;
      return draft;

    case EMAIL_BROWSER_ADD_EMAIL.ADD_SUCCESS:
      draft.addNewEmail.loading = false;
      // draft.addNewEmail.success = true;
      let onlyCampaign = action.payload.onlyCampaign;
      if (!onlyCampaign) draft.emails.data = [action.payload?.email, ...draft.emails?.data];
      if (action.payload?.campaignId) {
        draft.emailsInCampaign.data = [action.payload?.email, ...draft.emailsInCampaign.data];
      }
      return draft;

    case EMAIL_BROWSER_ADD_EMAIL.ADD_FAIL:
      draft.addNewEmail.loading = false;
      draft.addNewEmail.fail = true;
      return draft;

    case EMAIL_BROWSER_ADD_EMAIL.RESET:
      draft.addNewEmail.loading = false;
      draft.addNewEmail.success = false;
      draft.addNewEmail.fail = false;
      return draft;

    case EMAIL_BROWSER.REMOVE_EMAILS_OF_CAMPAIGN:
      let campaign_id = action.payload;
      if (campaign_id) {
        draft.emails.data.filter((item: any) => !item.campaignId || item.campaignId !== campaign_id);
        draft.emailsInCampaign.data.filter((item: any) => !item.campaignId || item.campaignId !== campaign_id);
      }
      return draft;

    /**
     *! Above this line are the updated/created for email changes
     *!
     *!
     *!------------------------------------------------------------
     */

    case EMAIL_BROWSER.CHANGE_TOTAL_ASSET_COUNT:
      if (action.payload.add) {
        draft.totalEmailsCount = draft.totalEmailsCount + 1;
      } else {
        draft.totalEmailsCount = draft.totalEmailsCount - 1;
      }
      draft.showRedColor = true;
      return draft;

    case EMAIL_BROWSER.SET_COLOR_RED:
      draft.showRedColor = true;
      return draft;

    case EMAIL_BROWSER.RESET_COLOR:
      draft.showRedColor = false;
      return draft;

    //* Adding a new asset to the list of assets in a campaing in asset BRowser
    case BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD:
      return draft;

    case BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_SUCCESS:
      console.log('PRINITNG THE ADDED CAMPAIGN');
      draft.emailsInCampaign = [...draft.emailsInCampaign, action.payload];
      return draft;

    case BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_FAIL:
      return draft;

    case BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_CAMPAIGN:
      let _object = draft.emails?.data.filter((item: any) => item.emailId === action.payload.emailId);
      let index = draft.emails?.data.findIndex((item: any) => item.emailId === action.payload.emailId);
      _object.campaignId = action.payload.campaignId;
      _object.campaignName = action.payload.campaignName;
      _object.lastUpdate = 'just now';
      draft.emails.data[index] = _object;

      return draft;
    case BROWSER_CREATE_ASSET.ADD:
      draft.loading = true;
      return draft;

    case BROWSER_CREATE_ASSET.ADD_SUCCESS:
      draft.loading = false;
      draft.newEmailCreated = true;
      draft.newAsset = [action.payload];
      return draft;

    case BROWSER_CREATE_ASSET.ADD_FAIL:
      draft.loading = false;
      return draft;

    case BROWSER_CREATE_ASSET_DRAFT.ADD:
      // draft.loading = true;
      draft.addNewEmail.loading = true;
      return draft;

    //* Update the Draft Name in the asset page
    case EDITION_NAME_CHANGE.SUCCESS:
      const { versionId, name } = action.payload;
      draft.editionsInAsset.map((item: any) => {
        if (item.edition_id === versionId) {
          item.name = name;
          item.subject = name;
        }
      });
      return draft;
    case EDITION_NAME_CHANGE.CURATED_COUNT_UPDATE:
      draft.emails.data.map((item: any) => {
        if (item.emailId === action.payload.versionId) {
          item.articlesCount = action.payload.count;
        }
        if (item.articlesCount === 0) {
          item.image = [DEFAULT_CAMPAIGN_IMAGE];
        }
      });
      draft.emailsInCampaign.data.map((item: any) => {
        if (item.emailId === action.payload.versionId) {
          item.articlesCount = action.payload.count;
        }
        if (item.articlesCount === 0) {
          item.image = [DEFAULT_CAMPAIGN_IMAGE];
        }
      });
      return draft;
    case BROWSER_CREATE_ASSET_DRAFT.ADD_SUCCESS:
      console.log('browser create asset draft');
      const queryAssetId = getQueryAssetId();
      const { edition, assetId } = action.payload;

      //* Updating the asset browser state.
      const data = draft.data.map((asset: any) => {
        if (asset.asset_id === assetId) {
          asset.editions = [edition, ...asset.editions];
        }
        return asset;
      });
      draft.data = [...data];

      //* Updating the assets in this Campaign.
      const dataTwo = draft.emailsInCampaign.map((asset: any) => {
        if (asset.asset_id === assetId) {
          asset.editions = [edition, ...asset.editions];
        }
        return asset;
      });
      draft.emailsInCampaign = [...dataTwo];

      //* Updating the Drafts in the asset page
      //* and the Drafts in the Draft/Edition Page
      if (assetId == queryAssetId) draft.editionsInAsset = [edition, ...draft.editionsInAsset];
      console.log(edition);
      draft.addNewEmail.loading = false;
      draft.addNewEmail.success = true;
      return draft;

    case BROWSER_CREATE_ASSET_DRAFT.ADD_FAIL:
      draft.addNewEmail.loading = false;
      draft.addNewEmail.success = false;
      draft.addNewEmail.fail = false;
      return draft;

    //* loading list for asset browser sidebar
    case BROWSER_EDITIONS_OF_CAMPAIGN.LOAD:
      return draft;

    case BROWSER_EDITIONS_OF_CAMPAIGN.LOAD_SUCCESS:
      draft.editionsInAsset = [...action.payload];
      return draft;

    case BROWSER_EDITIONS_OF_CAMPAIGN.LOAD_FAIL:
      return draft;

    case BROWSER_EDITIONS_OF_CAMPAIGN.SET_SINGLE_VERSION:
      draft.editionsInAsset = draft.editionsInAsset.filter((li: any) => li.edition_id === action.payload);
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD:
      draft.addEmail.loading = true;
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_SUCCESS:
      draft.addEmail.loading = false;
      draft.addEmail.success = true;
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_FAIL:
      draft.addEmail.loading = false;
      draft.addEmail.fail = true;
      return draft;

    case BROWSER_CREATE_ASSET_DRAFT.RESET_NEWLY_ADDED:
      let { draft_id, asset_id } = action.payload;
      if (draft_id && asset_id) {
        draft.data.forEach((element: any) => {
          if (element.asset_id === asset_id) {
            element.editions.map((item: any) => {
              if (item.edition_id === draft_id) {
                item.newlyCreated = false;
              }
              return item;
            });
          }
        });
        draft.editionsInAsset.map((elem: any) => {
          if (elem.edition_id === draft_id) {
            elem.newlyCreated = false;
          }
          return elem;
        });
        draft.emailsInCampaign.map((item: any) => {
          if (item.asset_id === asset_id) {
            item.editions.map((elem: any) => {
              if (elem.edition_id === draft_id) {
                elem.newlyCreated = false;
              }
              return elem;
            });
          }
          return item;
        });
      }

      return draft;

    case CAMPAIGN_DELETE.DECREMENT_ASSET_COUNT:
      if (draft.totalEmailsCount > 0) {
        draft.totalEmailsCount = draft.totalEmailsCount - parseInt(action.payload);
      }
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET:
      draft.addEmail.loading = false;
      draft.addEmail.success = false;
      draft.addEmail.fail = false;

      return draft;

    case BROWSER_REMOVE_ASSET_DRAFT.SUCCESS:
      let tbd_asset_id = action.payload.assetId;
      let tbd_edition_id = action.payload.editionId;
      console.log('BROWSER_REMOVE_ASSET_DRAFT_SUCCESS ', action.payload);
      draft.data = draft.data.map((item: any) => {
        if (item.asset_id === tbd_asset_id) {
          item.editions = item.editions.filter((elem: any) => elem.edition_id !== tbd_edition_id);
        }
        return item;
      });
      draft.editionsInAsset = draft.editionsInAsset.filter((elem: any) => elem.edition_id !== tbd_edition_id);
      // draft.emailsInCampaign = draft.emailsInCampaign.map((item: any) => {
      //   if (item.asset_id === article_Id) {
      //     item.editions.filter((elem: any) => elem.edition_id !== tbd_edition_id);
      //   }
      //   return item;
      // });
      return draft;

    case BROWSER_CREATED_ASSET_DRAFT.ADD:
      draft.addNewEmail.loading = true;
      return draft;

    case BROWSER_CREATED_ASSET_DRAFT.ADD_SUCCESS:
      draft.addNewEmail.loading = false;
      draft.addNewEmail.success = true;
      return draft;

    case BROWSER_CREATED_ASSET_DRAFT.ADD_FAIL:
      draft.addNewEmail.loading = false;
      draft.addNewEmail.fail = true;
      return draft;

    case BROWSER_CREATED_ASSET_DRAFT.RESET:
      draft.addNewEmail.loading = false;
      draft.addNewEmail.success = false;
      draft.addNewEmail.fail = false;
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ALREADY_ADDED_OPEN:
      draft.emailAlreadyExists = true;
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ALREADY_ADDED_CLOSE:
      draft.emailAlreadyExists = false;
      return draft;

    case EMAIL_BROWSER.SEARCH:
      draft.searchLoading = true;
      return draft;

    case EMAIL_BROWSER.SEARCH_SUCCESS:
      draft.searchLoading = false;
      draft.searchFail = false;
      draft.data = [...action.payload];

      return draft;

    case EMAIL_BROWSER.SEARCH_FAIL:
      draft.searchLoading = false;
      return draft;

    case EMAIL_BROWSER.SEARCH_RESET_NO_RESULT:
      draft.searchLoading = false;
      draft.searchFail = true;
      draft.data = [];
      return draft;

    case EMAIL_BROWSER.SEARCH_RESET:
      draft.searchLoading = false;
      draft.searchFail = false;
      draft.data = [];
      return draft;

    case EMAIL_BROWSER.RESET_EDITIONS_IN_ASSET:
      draft.editionsInAsset = [];
      return draft;

    default: {
      return draft;
    }
  }
});

export default emailBrowserReducer;
